<template>
  <div>
    <div class="registration_confirmation-wrapper" v-if="success">
      <div class="registration_confirmation-box">
        <div class="text-center mb-4"><img src="../assets/images/logo-dark.png" width="150" alt=""></div>
        <div class="registration_confirmation card">
          <div class="card-body">
            <div class="f-w-100 d-flex justify-content-center">
              <img src="../assets/images/check.png" width="100" alt="">
            </div>
            <p class="mt-3">
              Email has been verified. Please log in <a href="/auth/login">here</a>.
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="registration_confirmation-wrapper" v-if="error">
      <div class="registration_confirmation-box">
        <div class="text-center mb-4"><img src="../assets/images/logo-dark.png" width="150" alt=""></div>
        <div class="registration_confirmation card">
          <div class="card-body">
            <div class="f-w-100 d-flex justify-content-center">
              <img src="../assets/images/close-circular-button-symbol.png" width="100" alt="">
            </div>
            <p class="mt-3">
              Something wrong
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import stripeApi from "../services/stripeApi";

  export default {
    name: "confirm-email",
    data() {
      return {
        error: false,
        success: false
      }
    },
    watch: {
      '$route.query': {
        immediate: true,
        handler() {
          if (this.$route.query.token && this.$route.query.email) {
            stripeApi.confirmEmail(this.$route.query.token, this.$route.query.email).then((val) => {

              if(val.data.statusCode === 409 || val.data.statusCode === 400 ) {
                this.success = false;
                this.error = true;
              } else {
                this.success = true;
                this.error = false;
              }
            }).catch(() => {
              this.success = false;
              this.error = true;
            })
          } else {
            this.$router.push('/')
          }
        }
      }
    }
  }
</script>

<style scoped>
  .registration_confirmation-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 111;
    background-color: #f8f8f8;
    transition: 0.3s;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .registration_confirmation-wrapper .registration_confirmation {
    width: 600px;
  }

  .registration_confirmation-wrapper .registration_confirmation p {
    font-size: 18px;
    text-align: center;
    color: #494949;
  }

  .registration_confirmation-wrapper .registration_confirmation .card-footer {
    user-select: none;
    cursor: pointer;
  }

</style>
